export default class MenuColor {
	constructor() {

        this.targetItems = document.querySelectorAll('[data-invert-menu]');

        if(! this.targetItems) {
            return;
        }

        document.addEventListener('scroll', this.checkScroll.bind(this));
		this.checkScroll();

	}

    checkScroll() {

		const check = window.scrollY + 100;
        this.header = document.querySelector('[data-header]');

        Array.from(this.targetItems).every(target => {

            const rect = target.getBoundingClientRect();

			if (
                check >= rect.top + document.documentElement.scrollTop &&
				check <= rect.bottom + document.documentElement.scrollTop
            ) {

                this.header.classList.add('is-inverted');
                return false;

            } else {

                this.header.classList.remove('is-inverted');
                return true;
            }
		});
	}
}